export default __webpack_public_path__ + "static/media/Hermes_Desktop.73b94f19.mp4";